import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const NAV = [
    { label: "Services", href: "#services" },
    { label: "Safety", href: "#safety" },
    { label: "Gallery", href: "#gallery" },
    { label: "Contact", href: "#contact" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const { pathname } = useLocation();
    const overHero = pathname === "/";

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const darkText = scrolled || !overHero;

    return (
        <motion.header
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            data-testid="site-header"
            className={`fixed inset-x-0 top-[38px] z-50 transition-all duration-500 ${
                scrolled
                    ? "glass border-b border-brand-border/70"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
                <a
                    href="#top"
                    data-testid="logo-link"
                    className="group transition-transform hover:scale-[1.02]"
                >
                    <img
                        src={darkText ? "/monogram.png" : "/logo.png"}
                        alt="Treasure Valley Turf & Greens"
                        data-testid="site-logo"
                        className={`block h-16 w-auto max-w-none transition-opacity duration-300 md:h-20 ${
                            darkText
                                ? ""
                                : "[filter:drop-shadow(0_2px_6px_rgba(0,0,0,0.55))_drop-shadow(0_4px_18px_rgba(0,0,0,0.45))]"
                        }`}
                        draggable="false"
                    />
                </a>

                <nav className="hidden items-center gap-8 md:flex">
                    {NAV.map((n) => (
                        <a
                            key={n.label}
                            href={overHero ? n.href : `/${n.href}`}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={`text-sm font-medium transition-colors ${
                                darkText
                                    ? "text-brand-muted hover:text-brand-accent"
                                    : "text-white/80 hover:text-white"
                            }`}
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href="tel:+12086059096"
                        data-testid="header-phone"
                        className={`hidden text-sm font-semibold transition-colors lg:inline ${
                            darkText
                                ? "text-brand-text hover:text-brand-accent"
                                : "text-white hover:text-[#F0C06D]"
                        }`}
                    >
                        (208) 605-9096
                    </a>
                    <a
                        href="#quote"
                        data-testid="header-cta"
                        className="group inline-flex items-center gap-2 rounded-full bg-brand-accent px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 hover:bg-brand-accentHover hover:shadow-[0_8px_30px_-6px_rgba(184,128,31,0.5)]"
                    >
                        Free Quote
                        <span
                            aria-hidden
                            className="transition-transform group-hover:translate-x-0.5"
                        >
                            →
                        </span>
                    </a>
                </div>
            </div>
        </motion.header>
    );
};
